"use strict";
import React from "react";
import classNames from "classnames";
function ToolbarLink(props) {
  const { icon, enabled, action, href, title, active, label } = props;
  const className = {
    "icon--inactive": !enabled,
    "icon--highlight": active
  };
  const iconClassName = "icon-" + icon;
  className[iconClassName] = true;
  const labelElement = label ? /* @__PURE__ */ React.createElement("span", null, label) : "";
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      "data-component": "ToolbarLink",
      href,
      onClick: enabled ? action : void 0,
      title
    },
    /* @__PURE__ */ React.createElement("i", { className: classNames(className) }),
    labelElement
  );
}
export default ToolbarLink;
